import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Nav from "./Nav";

const titles = {
  "/": "Murat Gulcelik",
  "/works": "Works — Murat Gulcelik",
  "/about": "About — Murat Gulcelik",
  "/contact": "Contact — Murat Gulcelik",
  "/LearningMusic": "Learning Music — Murat Gulcelik",
};

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    document.title = titles[location.pathname] || "Murat Gulcelik";
  }, [location.pathname]);

  return (
    <div className="relative min-h-screen bg-white text-[var(--text)] flex flex-col">
      <Nav />
      <main className="pt-[60px] flex-1" key={location.pathname}>
        <Outlet />
      </main>
      <footer className="max-w-[800px] w-full mx-auto px-6 sm:px-8 py-10">
        <div className="border-t border-[var(--rule)] pt-6 flex flex-wrap gap-5 font-sans text-[12px]">
          <a
            href="https://instagram.com/muratgulcelik"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[var(--muted)] hover:text-[var(--text)] transition-colors"
          >
            Instagram
          </a>
          <a
            href="https://soundcloud.com/murat-gulcelik"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[var(--muted)] hover:text-[var(--text)] transition-colors"
          >
            SoundCloud
          </a>
          <a
            href="https://github.com/mrtglclk"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[var(--muted)] hover:text-[var(--text)] transition-colors"
          >
            GitHub
          </a>
          <a
            href="/equity-research"
            className="text-[var(--muted)] hover:text-[var(--text)] transition-colors"
          >
            Equity Research Portal
          </a>
        </div>
      </footer>
    </div>
  );
}
